import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AvTimerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"av_timer"}/>
}
